import { graphClient } from '../../graph-client'
import {
  CREATE_GAME_BOX_ROOM,
  EARNING_GAME_BOX_ROOM,
  GET_GAME_BOX_ROOM_EARNING,
  GET_GAMES_BOXES_ROOMS,
  UPDATE_GAME_BOX_ROOM,
} from './gql'

import type { Create, Earning, Get, GetList, Update } from './types'

class GameBoxRoomService {
  async get(params: Get.Input) {
    const request = await graphClient.request<Get.Output>(
      GET_GAME_BOX_ROOM_EARNING,
      params,
    )

    return request?.getGameBoxRoomEarning
  }

  async create(params: Create.Input) {
    const request = await graphClient.request<Create.Output>(
      CREATE_GAME_BOX_ROOM,
      params,
    )
    return request?.createGameBoxRoom
  }

  async update(params: Update.Input) {
    const request = await graphClient.request<Update.Output>(
      UPDATE_GAME_BOX_ROOM,
      params,
    )
    return request?.updateGameBoxRoom
  }

  async earning(params: Earning.Input) {
    const request = await graphClient.request<Earning.Output>(
      EARNING_GAME_BOX_ROOM,
      params,
    )

    return request?.earningGameBoxRoom
  }

  async getList({ take = 20, skip = 20, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_GAMES_BOXES_ROOMS,
      { ...params, skip: take * skip },
    )
    return request?.getGamesBoxesRooms
  }
}

export const gameBoxRoomService = new GameBoxRoomService()
